import { StaticImageData } from "next/image";
// images
import engineeringImage from "@/assets/images/prebuilt-ai-tab/engineering.svg";
import productManagementImage from "@/assets/images/prebuilt-ai-tab/product-management.svg";
import projectManagementImage from "@/assets/images/prebuilt-ai-tab/project-management.svg";
import operationsImage from "@/assets/images/prebuilt-ai-tab/operations.svg";
import itSupportImage from "@/assets/images/prebuilt-ai-tab/it-support.svg";
import hrImage from "@/assets/images/prebuilt-ai-tab/hr.svg";
import educationImage from "@/assets/images/prebuilt-ai-tab/education.svg";
import salesImage from "@/assets/images/prebuilt-ai-tab/sales.svg";
import qaImage from "@/assets/images/prebuilt-ai-tab/qa.svg";
import marketingImage from "@/assets/images/prebuilt-ai-tab/marketing.svg";

export type CategoryId =
  | "project"
  | "product"
  | "engineering"
  | "qa"
  | "marketing"
  | "sales"
  | "operations"
  | "it"
  | "hr"
  | "education";

export interface PrebuiltTabConfig {
  id: CategoryId;
  tabLabel: string;
  badgeLabel: string;
  image: StaticImageData;
}

export const PREBUILT_TABS_CONFIG: PrebuiltTabConfig[] = [
  {
    id: "project",
    tabLabel: "Project Management",
    badgeLabel: "Project Management",
    image: projectManagementImage,
  },
  {
    id: "product",
    tabLabel: "Product Management",
    badgeLabel: "Product Management",
    image: productManagementImage,
  },
  {
    id: "engineering",
    tabLabel: "Engineering",
    badgeLabel: "Engineering",
    image: engineeringImage,
  },
  {
    id: "qa",
    tabLabel: "QA",
    badgeLabel: "QA",
    image: qaImage,
  },
  {
    id: "marketing",
    tabLabel: "Marketing",
    badgeLabel: "Marketing",
    image: marketingImage,
  },
  {
    id: "sales",
    tabLabel: "Sales",
    badgeLabel: "Sales",
    image: salesImage,
  },
  {
    id: "operations",
    tabLabel: "Operations",
    badgeLabel: "Operations",
    image: operationsImage,
  },
  {
    id: "it",
    tabLabel: "IT Support",
    badgeLabel: "IT Support",
    image: itSupportImage,
  },
  {
    id: "hr",
    tabLabel: "HR",
    badgeLabel: "Human Resources",
    image: hrImage,
  },
  {
    id: "education",
    tabLabel: "Education",
    badgeLabel: "Education",
    image: educationImage,
  },
];
